export const permissionsStructure = [
	{
		portal: 'Administrator Portal',
		description: 'Permissions related to the admin portal.',
		permissions: [
			{
				label: 'Administrator Portal',
				value: 'admin_view',
				description: 'Ability to view the admin portal',
			},
		],
		categories: [
			{
				category: 'Overview',
				description: 'Permissions related to the overview page on the admin portal',
				permissions: [
					{
						value: 'admin_overview_view',
						label: 'Read Admin Overview',
						description: 'Ability to view the overview page in the admin portal',
					},
					{
						value: 'admin_overview_edit',
						label: 'Edit Admin Overview',
						description: 'Ability to edit information on the overview page in the admin portal',
					},
				],
			},
			{
				category: 'Tasks',
				description: 'Permissions related to the tasks in the admin portal',
				permissions: [
					{
						value: 'admin_user_tasks_status',
						label: 'Ability to Update User Task Status',
						description: 'Ability to update the status of user tasks in the admin portal',
					},
					{
						value: 'admin_group_tasks_status',
						label: 'Ability to Update Company Task Status',
						description: 'Ability to update the status of company tasks in the admin portal',
					},
					{
						value: 'admin_event_tasks_status',
						label: 'Ability to Update Event Task Status',
						description: 'Ability to update the status of event tasks in the admin portal',
					},
					{
						value: 'admin_group_tasks_delete',
						label: 'Delete Company Tasks',
						description: 'Ability to delete company tasks in the admin portal',
					},
					{
						value: 'admin_group_tasks_do',
						label: 'Do Company Tasks',
						description: 'Ability to do company tasks in the admin portal',
					},
					{
						value: 'admin_user_tasks_delete',
						label: 'Delete User Tasks',
						description: 'Ability to delete user tasks in the admin portal',
					},
					{
						value: 'admin_user_tasks_do',
						label: 'Do User Tasks',
						description: 'Ability to do user tasks in the admin portal',
					},
					{
						value: 'admin_event_tasks_delete',
						label: 'Delete Event Tasks',
						description: 'Ability to delete event tasks in the admin portal',
					},
					{
						value: 'admin_event_tasks_do',
						label: 'Do Event Tasks',
						description: 'Ability to do event tasks in the admin portal',
					},
				],
			},
			{
				category: 'Projects',
				description: 'Permissions related to projects in the admin portal',
				permissions: [
					{
						value: 'admin_projects_view',
						label: 'View Projects',
						description: 'Ability to view projects in the admin portal',
					},
					{
						value: 'admin_projects_create',
						label: 'Create Projects',
						description: 'Ability to create new projects in the admin portal',
					},
					{
						value: 'admin_projects_edit',
						label: 'Edit Projects',
						description: 'Ability to modify existing project information',
					},
					{
						value: 'admin_projects_archive',
						label: 'Archive Projects',
						description: 'Ability to archive and restore projects in the admin portal',
					},
				],
			},
			{
				category: 'Approvals',
				description: 'Permissions related to the approvals in the admin portal',
				permissions: [
					{
						value: 'admin_group_approvals_delete',
						label: 'Delete Company Approvals',
						description: 'Ability to delete company approvals in the admin portal',
					},
					{
						value: 'admin_user_approvals_delete',
						label: 'Delete User Approvals',
						description: 'Ability to delete user approvals in the admin portal',
					},
					{
						value: 'admin_event_approvals_delete',
						label: 'Delete Event Approvals',
						description: 'Ability to delete event approvals in the admin portal',
					},
				],
			},
			{
				category: 'Users',
				description: 'Permissions related to the users in the admin portal',
				permissions: [
					{
						value: 'admin_users_view',
						label: 'View Users',
						description: 'Ability to view user information in the admin portal',
					},
					{
						value: 'admin_users_review',
						label: 'Review Users',
						description: 'Ability to review and approve user changes',
					},
					{
						value: 'admin_users_create',
						label: 'Create Users',
						description: 'Ability to create new users in the admin portal',
					},
					{
						value: 'admin_users_edit',
						label: 'Edit Users',
						description: 'Ability to modify existing user information',
					},
					{
						value: 'admin_users_edit_email',
						label: 'Edit Users Email',
						description: 'Ability to edit the email of a user',
					},
					{
						value: 'admin_users_archive',
						label: 'Archive Users',
						description: 'Ability to archive or deactivate user accounts',
					},
					{
						value: 'admin_users_task_override',
						label: 'Override User Task Compliance',
						description: 'Ability to override the task compliance of a user',
					},
					{
						value: 'admin_users_blocklist',
						label: 'Block Users',
						description: 'Ability to block users & manage the blocklist',
					},
					{
						value: 'admin_users_import',
						label: 'Import Users',
						description: 'Ability to import users from a CSV file',
					},
				],
			},
			{
				category: 'Security',
				description: 'Permissions related to security in the admin portal',
				permissions: [
					{
						value: 'admin_security_block',
						label: 'Manage Blocklist & Blocking Users',
						description: 'Ability to manage the blocklist & blocking users in the admin portal',
					},
					{
						value: 'admin_security_block_companies',
						label: 'Blocking Companies',
						description: 'Ability to block companies in the admin portal',
					},
					{
						value: 'admin_security_accessmanagement',
						label: 'Manage Access Management',
						description: 'Ability to manage access management (creating new access badges) in the admin portal',
					},
					{
						value: 'admin_security_badge_printing',
						label: 'Manage Badge Printing',
						description: 'Ability to print badges in the admin portal',
					},
					{
						value: 'admin_security_emergency_mode',
						label: 'Manage Site Emergency Mode',
						description: 'Ability to enable or disable emergency mode for a site in the admin portal',
					},
					{
						value: 'receive_security_notifications',
						label: 'Receive Security Notifications',
						description:
							'Receive security-related email notifications (visitor flagged for review, host on the way to collect a visitor, etc.).',
					},
				],
			},
			{
				category: 'User Documents',
				description: 'Permissions related to the user documents in the admin portal',
				permissions: [
					{
						value: 'admin_userdocuments_view',
						label: 'View User Documents',
						description: 'Ability to view user documents in the admin portal',
					},
					{
						value: 'admin_sensitive_userdocuments_view',
						label: 'View Sensitive User Documents',
						description: 'Ability to view sensitive user documents in the admin portal',
					},
					{
						value: 'admin_sensitive_userdocuments_edit',
						label: 'Edit Sensitive User Documents',
						description: 'Ability to edit sensitive user documents in the admin portal',
					},
					{
						value: 'admin_sensitive_userdocuments_archive',
						label: 'Archive Sensitive User Documents',
						description: 'Ability to archive sensitive user documents in the admin portal',
					},
					{
						value: 'admin_userdocumentmetadata_view',
						label: 'View User Document Metadata',
						description: 'Ability to read metadata associated with user documents',
					},
					{
						value: 'admin_userdocuments_review',
						label: 'Review User Documents',
						description: 'Ability to review and approve user documents',
					},
					{
						value: 'admin_sensitive_userdocuments_review',
						label: 'Review Sensitive User Documents',
						description:
							'Ability to approve or reject sensitive user documents (e.g. IDs). Required in addition to reviewing for documents whose type is marked sensitive.',
					},
					{
						value: 'admin_userdocuments_create',
						label: 'Create User Documents',
						description: 'Ability to create new user documents in the admin portal',
					},
					{
						value: 'admin_userdocuments_edit',
						label: 'Edit User Documents',
						description: 'Ability to modify existing user documents',
					},
					{
						value: 'admin_userdocuments_archive',
						label: 'Archive User Documents',
						description: 'Ability to archive or remove user documents',
					},
				],
			},
			{
				category: 'Companies',
				description: 'Permissions related to the companies in the admin portal',
				permissions: [
					{
						value: 'admin_groups_view',
						label: 'View Companies',
						description: 'Ability to view companies in the admin portal',
					},
					{
						value: 'admin_groups_review',
						label: 'Review Companies',
						description: 'Ability to review and approve company information',
					},
					{
						value: 'admin_groups_create',
						label: 'Create Companies',
						description: 'Ability to create new companies in the admin portal',
					},
					{
						value: 'admin_groups_edit',
						label: 'Edit Companies',
						description: 'Ability to modify existing company information',
					},
					{
						value: 'admin_groups_archive',
						label: 'Archive Companies',
						description: 'Ability to archive or deactivate companies',
					},
				],
			},
			{
				category: 'Events',
				description: 'Permissions related to the events in the admin portal',
				permissions: [
					{
						value: 'admin_events_view',
						label: 'View Events',
						description: 'Ability to view events in the admin portal',
					},
					{
						value: 'admin_events_review',
						label: 'Review Events',
						description: 'Ability to review and approve event information',
					},
					{
						value: 'admin_events_create',
						label: 'Create Events',
						description: 'Ability to create new events in the admin portal',
					},
					{
						value: 'admin_events_edit',
						label: 'Edit Events',
						description: 'Ability to modify existing event information',
					},
					{
						value: 'admin_events_archive',
						label: 'Archive Events',
						description: 'Ability to archive or deactivate events',
					},
					{
						value: 'admin_events_exception',
						label: 'Process Event Exception',
						description: 'Ability to initiate, accept, and cancel the exception procedure on events',
					},
					{
						value: 'admin_events_tasks_do',
						label: 'Do Event Tasks',
						description: 'Ability to do tasks related to events',
					},
					{
						value: 'admin_events_tasks_delete',
						label: 'Delete Event Tasks',
						description: 'Ability to delete tasks related to events',
					},
				],
			},
			{
				category: 'Logs',
				description: 'Permissions related to the logs in the admin portal',
				permissions: [
					{
						value: 'admin_accesslogs_view',
						label: 'View Access Logs',
						description: 'Ability to view access logs in the admin portal',
					},
					{
						value: 'admin_eventlogs_view',
						label: 'View Event Logs',
						description: 'Ability to view event logs in the admin portal',
					},
					{
						value: 'admin_grouplogs_view',
						label: 'View Company Logs',
						description: 'Ability to view company logs in the admin portal',
					},
					{
						value: 'admin_userlogs_view',
						label: 'View User Logs',
						description: 'Ability to view user logs in the admin portal',
					},
					{
						value: 'admin_notificationlogs_view',
						label: 'View Notification Logs',
						description: 'Ability to view notification logs in the admin portal',
					},
					{
						value: 'admin_reports_view',
						label: 'View Reports',
						description: 'Ability to view reports in the admin portal',
					},
				],
			},
			{
				category: 'Invites',
				description: 'Permissions related to invites in the admin portal',
				permissions: [
					{
						value: 'admin_external_calendar_invites',
						label: 'Send External Calendar Invites',
						description:
							'Ability to invite users via a calendar invite whose email address is not on the domain allow list.',
					},
				],
			},
		],
	},
	{
		portal: 'Company Portal',
		description: 'Permissions related to the company portal, suitable for contractors.',
		permissions: [
			{
				label: 'Company Portal',
				value: 'company_view',
				description: 'Ability to view the company portal',
			},
		],
		categories: [
			{
				category: 'Overview',
				description: 'Permissions related to the overview page on the company portal',
				permissions: [
					{
						value: 'company_overview_view',
						label: 'Read Company Overview',
						description: 'Ability to view the overview page on the company portal',
					},
				],
			},
			{
				category: 'Tasks',
				description: 'Permissions related to tasks related to your company',
				permissions: [
					{
						value: 'company_tasks_view',
						label: 'View Company Tasks',
						description: 'Ability to view tasks related to your company',
					},
					{
						value: 'company_tasks_do',
						label: 'Perform Company Tasks',
						description: 'Ability to perform tasks related to your company',
					},
				],
			},
			{
				category: 'Users',
				description: 'Permissions related to users related to your company',
				permissions: [
					{
						value: 'company_users_view',
						label: 'Read Company Users',
						description: 'Ability to view users related to your company',
					},
					{
						value: 'company_users_create',
						label: 'Create Company Users',
						description: 'Ability to create new users for your company',
					},
					{
						value: 'company_users_edit',
						label: 'Edit Company Users',
						description: 'Ability to modify existing users in your company',
					},
					{
						value: 'company_users_archive',
						label: 'Archive Company Users',
						description: 'Ability to archive or deactivate users in your company',
					},
				],
			},
			{
				category: 'Own Events',
				description: 'Permissions related to events that your company owns',
				permissions: [
					{
						value: 'company_events_view',
						label: 'Read Company Events',
						description: 'Ability to view events related to your company',
					},
					{
						value: 'company_events_create',
						label: 'Create Company Events',
						description: 'Ability to create events related to your company',
					},
					{
						value: 'company_events_edit',
						label: 'Edit Company Events',
						description: 'Ability to edit events related to your company',
					},
					{
						value: 'company_events_tasks_do',
						label: 'Perform Company Events Tasks',
						description: 'Ability to perform tasks related to your company',
					},
				],
			},
			{
				category: 'Participating Events',
				description: 'Permissions related to events related to your company',
				permissions: [
					{
						value: 'company_participating_events_view',
						label: 'Read Company Events',
						description: 'Ability to view events related to your company',
					},
				],
			},
			{
				category: 'Projects',
				description: 'Permissions related to projects related to your company',
				permissions: [
					{
						value: 'company_projects_view',
						label: 'Read Company Projects',
						description: 'Ability to view projects related to your company',
					},
					{
						value: 'company_projects_create_event',
						label: 'Create Events Company Project',
						description: 'Ability to create events on projects related to your company',
					},
				],
			},
			{
				category: 'Main Contractor Events',
				description: 'Permissions related to events where you are a contractor',
				permissions: [
					{
						value: 'company_maincontractor_events_view',
						label: 'Read Main Contractor Events',
						description: 'Ability to view events related to your company',
					},
					{
						value: 'company_maincontractor_events_documents_create',
						label: 'Upload Event Documents',
						description: 'Ability to upload documents for main contractor events',
					},
					{
						value: 'company_maincontractor_events_editDetails',
						label: 'Edit Event Details',
						description: 'Ability to edit the details of events',
					},
				],
			},
			{
				category: 'Documents',
				description: 'Permissions related to documents related to your company',
				permissions: [
					{
						value: 'company_documents_create',
						label: 'Create Company Documents',
						description: 'Ability to create documents for your company',
					},
					{
						value: 'company_documents_edit',
						label: 'Edit Company Documents',
						description: 'Ability to edit documents for your company',
					},
					{
						value: 'company_documents_view',
						label: 'Read Company Documents',
						description: 'Ability to read documents for your company',
					},
				],
			},
			{
				category: 'Approvals',
				description: 'Permissions related to approvals related to your company',
				permissions: [
					{
						value: 'company_approvals_tasks_do',
						label: 'Perform Company Approvals Tasks',
						description: 'Ability to perform tasks related to your company',
					},
				],
			},
		],
	},
	{
		portal: 'Supervisor Portal',
		description: 'Permissions related to the supervisor portal.',
		permissions: [
			{
				label: 'Supervisor Portal',
				value: 'supervisor_view',
				description: 'Ability to view the supervisor portal',
			},
		],
		categories: [
			{
				category: 'Security',
				description: 'Permissions related to security in the supervisor portal',
				permissions: [
					{
						value: 'supervisor_security_access_management',
						label: 'Manage Access Management',
						description: 'Ability to manage access management (creating new access badges) in the supervisor portal',
					},
				],
			},
		],
	},
	{
		portal: 'Personal Dashboard',
		description: 'Permissions related to the personal dashboard, suitable for employees.',
		permissions: [
			{
				label: 'Personal Dashboard',
				value: 'personal_view',
				description: 'Ability to view the personal dashboard',
			},
		],
		categories: [
			{
				category: 'Overview',
				description: 'Permissions related to the overview page on the personal dashboard',
				permissions: [
					{
						value: 'personal_overview_view',
						label: 'Read Personal Overview',
						description: 'Ability to view the overview page on the personal dashboard',
					},
				],
			},
			{
				category: 'My Tasks',
				description: 'Permissions related to your own tasks',
				permissions: [
					{
						value: 'personal_tasks_do',
						label: 'View & Do My Tasks',
						description: 'Ability to view your own tasks and perform them',
					},
					{
						value: 'personal_tasks_view',
						label: 'View My Tasks',
						description: 'Ability to view your own tasks',
					},
				],
			},
			{
				category: 'Projects',
				description: 'Permissions related to the projects',
				permissions: [
					{
						value: 'personal_projects_view',
						label: 'Read Projects',
						description: 'Ability to view projects',
					},
					{
						value: 'personal_projects_create',
						label: 'Create Projects',
						description: 'Ability to create projects',
					},
					{
						value: 'personal_projects_edit',
						label: 'Edit Projects',
						description: 'Ability to edit projects',
					},
					{
						value: 'personal_projects_archive',
						label: 'Archive Projects',
						description: 'Ability to archive projects',
					},
				],
			},
			{
				category: 'Own Events',
				description: 'Permissions related to the events where you are the owner',
				permissions: [
					{
						value: 'personal_own_events_view',
						label: 'Read Own Events',
						description: 'Ability to view events where you are the owner',
					},
					{
						value: 'personal_own_events_edit',
						label: 'Edit Own Events',
						description: 'Ability to edit events where you are the owner',
					},
					{
						value: 'personal_own_events_details',
						label: 'Edit Own Event Details',
						description: 'Ability to edit the details of events where you are the owner',
					},
					{
						value: 'personal_own_events_archive',
						label: 'Archive Own Events',
						description: 'Ability to archive events where you are the owner',
					},
					{
						value: 'personal_own_events_tasks_do',
						label: 'Do Own Events Tasks',
						description: 'Ability to do tasks related to events where you are the owner',
					},
					{
						value: 'personal_own_events_tasks_delete',
						label: 'Delete Own Events Tasks',
						description: 'Ability to delete tasks related to events where you are the owner',
					},
					{
						value: 'personal_own_events_user_import',
						label: 'Import User to Own Events',
						description: 'Ability to import users to events where you are the owner',
					},
					{
						value: 'personal_own_events_users_view',
						label: 'View Users in Own Events',
						description: 'Ability to view user information in events where you are the owner',
					},
				],
			},
			{
				category: 'Pool Events',
				description:
					'Permissions related to events organised by anyone sharing one of your Internal Departments (co-organiser pool)',
				permissions: [
					{
						value: 'personal_pool_events_view',
						label: 'Read Pool Events',
						description:
							'Ability to view events organised by anyone in your Internal Department(s), without being the explicit organiser',
					},
					{
						value: 'personal_pool_events_edit',
						label: 'Edit Pool Events',
						description:
							'Ability to edit events organised by anyone in your Internal Department(s), without being the explicit organiser',
					},
					{
						value: 'personal_pool_events_archive',
						label: 'Archive Pool Events',
						description:
							'Ability to archive events organised by anyone in your Internal Department(s), without being the explicit organiser',
					},
				],
			},
			{
				category: 'All Events',
				description: 'Permissions related to all events, including events that are not their own',
				permissions: [
					{
						value: 'personal_all_events_view',
						label: 'Read All Events',
						description: 'Ability to view all events, including those not owned by the user',
					},
					{
						value: 'personal_all_events_create',
						label: 'Create Events',
						description: 'Ability to create new events',
					},
					{
						value: 'personal_all_events_edit',
						label: 'Edit All Events',
						description: 'Ability to edit all events, including those not owned by the user',
					},
					{
						value: 'personal_all_events_archive',
						label: 'Archive All Events',
						description: 'Ability to archive all events, including those not owned by the user',
					},
					{
						value: 'personal_all_events_user_import',
						label: 'Import Users to all Events',
						description: 'Ability to import users to all events',
					},
					{
						value: 'personal_all_events_users_view',
						label: 'View Users in All Events',
						description: 'Ability to view user information across all events in the personal portal',
					},
				],
			},
			{
				category: 'All Companies',
				description:
					'Permissions related to all companies, Users can already view their own company through the company portal.',
				permissions: [
					{
						value: 'personal_groups_view',
						label: 'View All Companies',
						description: 'Ability to view all companies in the system',
					},
					{
						value: 'personal_groups_create',
						label: 'Create Companies',
						description: 'Ability to create new companies',
					},
					{
						value: 'personal_groups_edit',
						label: 'Edit Companies',
						description: 'Ability to edit existing companies',
					},
					{
						value: 'personal_groups_documents',
						label: 'Manage Companies Documents',
						description: 'Ability to upload, edit, and delete documents for companies',
					},
					{
						value: 'personal_groups_users',
						label: 'Manage Companies Users',
						description: 'Ability to add, remove, and manage users within companies',
					},
					{
						value: 'personal_groups_events',
						label: 'Manage Companies Events',
						description: 'Ability to add, remove, and manage events within companies',
					},
					{
						value: 'personal_groups_block',
						label: 'Block Companies',
						description: 'Ability to block or suspend companies',
					},
					{
						value: 'personal_groups_logs',
						label: 'View Company Logs',
						description: 'Ability to view logs for companies',
					},
				],
			},
		],
	},
	{
		portal: 'Partner Portal',
		description: 'Permissions related to the partner portal, suitable for partner companies.',
		permissions: [
			{
				label: 'Partner Portal',
				value: 'partner_company_view',
				description: 'Ability to view the partner portal',
			},
		],
		categories: [
			{
				category: 'Overview',
				description: 'Permissions related to the overview page on the partner portal',
				permissions: [
					{
						value: 'partner_company_overview_view',
						label: 'Read Partner Company Overview',
						description: 'Ability to view the overview page on the partner portal',
					},
				],
			},
			{
				category: 'Tasks',
				description: 'Permissions related to tasks related to your partner company',
				permissions: [
					{
						value: 'partner_company_tasks_view',
						label: 'View Partner Company Tasks',
						description: 'Ability to view tasks related to your partner company',
					},
					{
						value: 'partner_company_tasks_do',
						label: 'Perform Partner Company Tasks',
						description: 'Ability to perform tasks related to your partner company',
					},
				],
			},
			{
				category: 'Users',
				description: 'Permissions related to users related to your partner company',
				permissions: [
					{
						value: 'partner_company_users_view',
						label: 'Read Partner Company Users',
						description: 'Ability to view users related to your partner company',
					},
					{
						value: 'partner_company_users_create',
						label: 'Create Partner Company Users',
						description: 'Ability to create new users for your partner company',
					},
					{
						value: 'partner_company_users_edit',
						label: 'Edit Partner Company Users',
						description: 'Ability to modify existing users in your partner company',
					},
					{
						value: 'partner_company_users_archive',
						label: 'Archive Partner Company Users',
						description: 'Ability to archive or deactivate users in your partner company',
					},
				],
			},
			{
				category: 'Projects',
				description: 'Permissions related to projects related to your partner company',
				permissions: [
					{
						value: 'partner_company_projects_view',
						label: 'Read Partner Company Projects',
						description: 'Ability to view projects related to your partner company',
					},
					{
						value: 'partner_company_projects_create',
						label: 'Create Partner Company Projects',
						description: 'Ability to create projects related to your partner company',
					},
					{
						value: 'partner_company_projects_edit',
						label: 'Edit Partner Company Projects',
						description: 'Ability to edit projects related to your partner company',
					},
					{
						value: 'partner_company_projects_archive',
						label: 'Archive Partner Company Projects',
						description: 'Ability to archive projects related to your partner company',
					},
				],
			},
			{
				category: 'Own Events',
				description: 'Permissions related to events that your partner company owns',
				permissions: [
					{
						value: 'partner_company_events_view',
						label: 'Read Partner Company Events',
						description: 'Ability to view events related to your partner company',
					},
					{
						value: 'partner_company_events_create',
						label: 'Create Partner Company Events',
						description: 'Ability to create events related to your partner company',
					},
					{
						value: 'partner_company_events_edit',
						label: 'Edit Partner Company Events',
						description: 'Ability to edit events related to your partner company',
					},
					{
						value: 'partner_company_events_tasks_do',
						label: 'Perform Partner Company Events Tasks',
						description: 'Ability to perform tasks related to your partner company',
					},
				],
			},
			{
				category: 'Documents',
				description: 'Permissions related to documents related to your partner company',
				permissions: [
					{
						value: 'partner_company_documents_create',
						label: 'Create Partner Company Documents',
						description: 'Ability to create documents for your partner company',
					},
					{
						value: 'partner_company_documents_edit',
						label: 'Edit Partner Company Documents',
						description: 'Ability to edit documents for your partner company',
					},
					{
						value: 'partner_company_documents_view',
						label: 'Read Partner Company Documents',
						description: 'Ability to read documents for your partner company',
					},
					{
						value: 'partner_company_documents_archive',
						label: 'Archive Partner Company Documents',
						description: 'Ability to archive documents for your partner company',
					},
				],
			},
			{
				category: 'Approvals',
				description: 'Permissions related to approvals related to your partner company',
				permissions: [
					{
						value: 'partner_company_approvals_tasks_do',
						label: 'Perform Partner Company Approvals Tasks',
						description: 'Ability to perform tasks related to your partner company',
					},
				],
			},
		],
	},
] as const;
